import { AuthService } from './services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],

})
export class LoginComponent implements OnInit {
  protected showLoader: boolean;
  protected loginForm: UntypedFormGroup;
  protected email: string;
  protected password: string;
  protected firebaseErrorMessage: string;
  confirmBtn: boolean;
  checkEmailBtn: boolean;
  submitted: boolean = false; // <-- NEW FLAG

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
    this.showLoader = false;
    this.loginForm = new UntypedFormGroup({
      'email': new UntypedFormControl('', [Validators.required, Validators.email]),
      'password': new UntypedFormControl('', Validators.required)
    });
  }

  public ngOnInit(): void {
    this.authService.isAuthenticated().pipe(take(1)).subscribe((isAuthenticated) => {
      if (isAuthenticated) this.router.navigate(['/partner']);
    });

    // clear firebaseErrorMessage on form change
    this.loginForm.valueChanges.subscribe(() => {
      if (this.firebaseErrorMessage) this.firebaseErrorMessage = '';
    });
  }

  public get formErrors(): string[] {
    const errors: string[] = [];

    if (!this.submitted) return errors; // ← Only check after submission

    const emailCtrl = this.loginForm.get('email');
    const passwordCtrl = this.loginForm.get('password');

    if (emailCtrl && emailCtrl.invalid) {
      if (emailCtrl.errors?.['required']) errors.push('Email is required.');
      if (emailCtrl.errors?.['email']) errors.push('Enter a valid email address.');
    }

    if (passwordCtrl && passwordCtrl.invalid) {
      if (passwordCtrl.errors?.['required']) errors.push('Password is required.');
    }

    return errors;
  }

  protected login(): void {
    this.submitted = true;

    if (this.loginForm.invalid) return;

    this.showLoader = true;

    this.authService.login(this.loginForm.value.email, this.loginForm.value.password)
      .then(() => {
        this.showLoader = false;
        this.router.navigate(['/partner']);
      }).catch(err => {
        this.showLoader = false;
        this.firebaseErrorMessage = err.message;
      });
  }

  protected resetPassword(): void {
    this.confirmBtn = true;
    this.checkEmailBtn = false;
  }

  protected confirmReset(): void {
    this.authService.resetPassword(this.email).then(() => {
      this.checkEmailBtn = true;
      this.confirmBtn = false;
    });
  }

  protected return(): void {
    this.confirmBtn = false;
    this.checkEmailBtn = false;
    this.firebaseErrorMessage = '';
    this.submitted = false;
  }
}
